import React from "react";
import {
  AccountCircle as AccountCircleIcon,
  BarChart as BarChartIcon,
  YouTube as YouTubeIcon,
  AddLink as AddLinkIcon,
  Edit as EditIcon,
  EditRounded,
} from "@mui/icons-material";

// Menu items ko yahan se export karein
export const menuItems = [
  { text: "Analytics", icon: <BarChartIcon />, page: "analytics" },

  // Yeh item ab sub-menus ke saath hai
  {
    text: "Youtube",
    icon: <YouTubeIcon />,
    page: "youtube", // Parent ke liye ek unique page name
    subItems: [
      { text: "Add Link", icon: <AddLinkIcon />, page: "addLink" },
      { text: "Update Link", icon: <EditIcon />, page: "updateLink" },
    ],
  },
  { text: "Profile", icon: <AccountCircleIcon />, page: "profile" },
  { text: "Editor", icon: <EditRounded />, page: "blogEditor" },
];
